<template>
  <div class="sz-tags flex flex-wrap">
    <div
      class="pri-tag flex items-center h-43px leading-43px rounded-5px px-15px mr-11px mt-11px text-pri"
      v-for="(item, index) in tags"
      :key="index"
    >
      <span>{{ item.name }}</span>
      <img
        src="@/assets/images/pri_close.png"
        class="w-19px h-19px ml-8px cursor-pointer"
        @click="deleteItem(item, index)"
      />
    </div>
    <el-input
      class="w-100px h-43px mt-11px mr-11px"
      style="flex: none;"
      v-if="inputVisible"
      v-model="inputValue"
      ref="saveTagInput"
      size="small"
      maxlength="16"
      @keyup.enter.native="handleInputConfirm"
      @blur="handleInputConfirm"
      @input="input"
    >
    </el-input>
    <el-button
      v-else
      icon="el-icon-plus"
      class="pri-tag h-43px mt-11px"
      @click="addTag"
      >添加标签</el-button
    >
  </div>
</template>

<script>
export default {
  props: {
    tags: {}
  },
  data() {
    return {
      inputVisible: false,
      inputValue: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    deleteItem(item, index) {
      this.$emit('delete', { item, index })
    },
    // 添加标签
    addTag() {
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    // 确定添加标签事件
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.$emit('confirm', inputValue)
      }
    },
    // 添加完成
    finishAdd() {
      this.inputVisible = false
      this.inputValue = ''
    },
    input(){
      this.$nextTick(() => {
      this.updateInputWidth();
    });
    },
    updateInputWidth() {
    const input = this.$refs.saveTagInput.$el.querySelector('input');
    input.style.width = `${input.scrollWidth}px`;
   }
  }
}
</script>
<style lang="scss" scoped>

.sz-tags {
  margin-top: -11px;
}

</style>
